module.exports = __webpack_public_path__ + "img/14-1.6bb6d052.png";